<template>
  <HeroView
      title="Mix"
      text="Feature-packed, advanced, and optimized for large-scale selling — with high-impact sales tools and conversion-driven design, built to grow profits and accelerate store expansion."
      purchase-link="https://themes.shopify.com/themes/mix/presets/mix"
      price="$380"
      img-main="/assets/imgs/themes/mix/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/mix/hero/hero.webp 1x, /assets/imgs/themes/mix/hero/hero@2x.webp 2x"
  />

  <DemosView
      title="5 Conversion-Driven <br>Pre-Built Presets"
      text="Explore 5 powerful presets — engineered to boost sales and produce real results with proven layouts and features."
      theme-id="mix"
  />
  <BannerView
      title="Turn Your Store Into a Conversion Machine"
      text="Maximize sales and engagement by turning your store into a high-converting experience. Every element is designed to guide visitors smoothly from discovery to checkout."
      purchase-link="https://themes.shopify.com/themes/mix/presets/mix"
      price="$380"
      img-main="/assets/imgs/themes/mix/banner@2x.webp"
      img-set="/assets/imgs/themes/mix/banner.webp 1x, /assets/imgs/themes/mix/banner@2x.webp 2x"
  />
  <FeaturesView/>
  <BuiltView/>
  <DocView
      doc-link="/help-center/documentation/mix/"
      img-main="/assets/imgs/themes/mix/doc/doc@2x.webp"
      img-set="/assets/imgs/themes/mix/doc/doc.webp 1x, /assets/imgs/themes/mix/doc/doc@2x.webp 2x"
  />
  <FinalView
      title="Conversion Magic Starts with Mix"
      text="Whether you’re launching a new brand or scaling an existing store, Mix is your secret weapon for turning traffic into loyal customers."
      purchase-link="https://themes.shopify.com/themes/mix/presets/mix"
      price="$380"
      img-main="/assets/imgs/themes/mix/final@2x.webp"
      img-set="/assets/imgs/themes/mix/final.webp 1x, /assets/imgs/themes/mix/final@2x.webp 2x"
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'MixView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>
